<template>
  <GmapMap
    ref="gmap"
    class="lead__map m-auto px-3 h-100"
    :options="mapOptions"
    :center="marker"
    :zoom="15"
    map-type-id="terrain"
  >
    <GmapMarker
      :position="marker"
      :clickable="true"
      :draggable="true"
    />
  </GmapMap>
</template>

<script>
import {gmapApi} from 'vue2-google-maps';

export default {
  name: "LeadMap",
  props: ["marker"],
  data: function() {
    return {
      mapOptions: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: true,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false,
        zoomControlOptions: {
          position: 5
        }
      }
    }
  },
  computed: {
    google: gmapApi,
  }
}
</script>

<style scoped lang="scss">
.lead__map {
  min-height: 250px;
  width: 100%;
}
</style>
